import { render, staticRenderFns } from "./TabDetalleCE.vue?vue&type=template&id=43d31ffa&"
import script from "./TabDetalleCE.vue?vue&type=script&lang=js&"
export * from "./TabDetalleCE.vue?vue&type=script&lang=js&"
import style0 from "./TabDetalleCE.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports